
import './Dashboard.module.css';
import React from 'react';
import DashboardHeader from './DashboardHeader';
import AccountSettingsView from './AccountSettingsView';
import ActiveServerView from './ActiveServerView';
import GetStartedView from './GetStartedView';

import {
  Switch,
  Route
} from "react-router-dom";
import ServerSettingsView from './ServerSettingsView';

class Dashboard extends React.Component {

  Dashboard() {
    return (
      <div>ayaya</div>
    );
  }

  componentDidMount(){
    const requestOptions = {
      method: 'GET',
      headers: 
      {
        "authorization": localStorage.getItem("user_token")
      }
    };
  
    fetch(process.env.REACT_APP_INTERNAL_API_DOMAIN + 'user/me', requestOptions)
    .then(response => {
      if(response.status === 401 || response.status === 403)
      {
        console.log("Forcing the user to re-authorize:");
        window.location.href = `https://discord.com/oauth2/authorize?client_id=611247115829510165&redirect_uri=${process.env.REACT_APP_DISCORD_REDIRECTURI}&response_type=code&scope=identify%20guilds`; 
        return null;
      }
      return response;
    })
    .then(response => response.json())
    .then(data => {

      console.log("LOGGED IN AS:");
      console.log(data);
    });
  }
  
  componentDidUpdate()
  {

  }


  render(){
    return <div>
      <DashboardHeader />
        <Switch>
          <Route exact path="/dashboard/account">
            <AccountSettingsView />
          </Route>
          <Route exact path="/dashboard/active">
            <ActiveServerView />
          </Route>
          <Route exact path="/dashboard/get-started">
            <GetStartedView />
          </Route>
          <Route path="/dashboard/server/:guildid" render={({match}) => (
            <ServerSettingsView guildid={match.params.guildid}/>
          )}/>
        {/*
        <Route path="/about">
          <About />
        </Route>
        <Route path="/dashboard">
          <Dashboard />
        </Route>
        */}
      </Switch>
    </div>;
      
  }

}





export default Dashboard;
